import { render, staticRenderFns } from "./noPageFound.vue?vue&type=template&id=19159bbf"
var script = {}
import style0 from "./noPageFound.vue?vue&type=style&index=0&id=19159bbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports